/**
 * Module definition for import module. The import module manages
 * the application's top-level import view (i.e., /import).
 *
 * @module routes.import
 */

angular.module('routes.import', [
  'routes.import.ImportController',
  'routes.import.ImportPayloadResolver'
])
.config(
  [
    '$stateProvider',
    function ($stateProvider) {
      'use strict';

      $stateProvider
        .state('routes.import', {
          url: '/import',
          templateUrl: 'routes/import/import.html',
          controller: 'ImportController',
          params: {},
          resolve: {
            importPayload: [
              'ImportPayloadResolver',
              '$stateParams',
              'newmanPayload',
              function (ImportPayloadResolver, $stateParams, newmanPayload) {
                return new ImportPayloadResolver($stateParams, newmanPayload);
              }
            ]
          }
        }
      );
    }
  ]
);
